"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _config = _interopRequireDefault(require("../../config"));

var tokenUtil = _interopRequireWildcard(require("../../token/utils/token"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable prefer-promise-reject-errors */
var MODULE_NAME = 'sdk/api/services/api';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var MISSING_PARAMS = 'MISSING_PARAMS';
/**
 *
 * @param {{object: string, action: string}} params
 * @returns {boolean}
 * @private
 */

var hasParams = function hasParams(params) {
  logger.debug("".concat(MODULE_NAME, " - hasParams called"), params);
  return !!(params && params.object && params.action);
};
/**
 * Fixes any protocol issues in the uri
 * @param uri
 * @returns {`https://${*}`}
 */


var baseUrl = function baseUrl(uri) {
  logger.info("".concat(MODULE_NAME, " - baseUrl"), uri);
  var replaced = uri === null || uri === void 0 ? void 0 : uri.replace('https://', '').replace('https:', '').replace('https', '');
  logger.info("".concat(MODULE_NAME, " - baseUrl result"), "https://".concat(replaced));
  return "https://".concat(replaced);
};
/**
 *
 * @param params
 * @return {*}
 */


var get = function get(params) {
  logger.info("".concat(MODULE_NAME, " - get called"), params);

  if (!_config.default.hasValidConfig()) {
    console.error('nsSDK not configured'); // eslint-disable-next-line prefer-promise-reject-errors

    return Promise.reject(false);
  }

  if (!hasParams(params)) {
    console.error("".concat(MODULE_NAME, " - get missing params"));
    return Promise.reject(MISSING_PARAMS);
  }

  var _config$getConfigurat = _config.default.getConfiguration(),
      apiURL = _config$getConfigurat.apiURL;

  var token = tokenUtil.get();
  var request = {
    method: 'get',
    baseURL: baseUrl(apiURL),
    params: params
  };

  if (token) {
    request.headers = {
      Authorization: "Bearer ".concat(token)
    };
    request.withCredentials = true;
  }

  return (0, _axios.default)(request).then(function (res) {
    logger.debug("".concat(MODULE_NAME, " - get res"), res);
    return res.data;
  });
};
/**
 *
 * @param params
 * @returns {Promise}
 */


var getLogo = function getLogo(params) {
  logger.info("".concat(MODULE_NAME, " - getLogo called"), params);

  if (!_config.default.hasValidConfig()) {
    console.error('nsSDK not configured');
    return Promise.reject(false);
  }

  var _config$getConfigurat2 = _config.default.getConfiguration(),
      apiURL = _config$getConfigurat2.apiURL;

  return new Promise(function (resolve, reject) {
    (0, _axios.default)({
      method: 'get',
      baseURL: baseUrl(apiURL),
      params: params,
      responseType: 'blob'
    }).then(function (res) {
      var reader = new FileReader(); // eslint-disable-next-line func-names

      reader.onloadend = function () {
        resolve(this.result);
      };

      reader.readAsDataURL(res.data);
    }).catch(function () {
      reject();
    });
  });
};
/**
 *
 * @param params
 * @param payload
 */


var post = function post(params, payload) {
  logger.info("".concat(MODULE_NAME, " - post called"), {
    params: params,
    payload: payload
  });

  if (!_config.default.hasValidConfig()) {
    console.error('nsSDK not configured');
    return Promise.reject(false);
  }

  if (!hasParams(params) && !payload) {
    console.error("".concat(MODULE_NAME, " - post missing params"));
    return Promise.reject(MISSING_PARAMS);
  }

  var _config$getConfigurat3 = _config.default.getConfiguration(),
      apiURL = _config$getConfigurat3.apiURL;

  var token = tokenUtil.get();
  var request = {
    method: 'post',
    baseURL: baseUrl(apiURL),
    params: params,
    data: payload
  };
  logger.info("".concat(MODULE_NAME, " - post url"), request);

  if (token) {
    request.headers = {
      Authorization: "Bearer ".concat(token)
    };
    request.withCredentials = true;
  }

  return (0, _axios.default)(request).then(function (res) {
    logger.debug("".concat(MODULE_NAME, " - post res"), res);
    return res.data;
  });
};
/**
 * @param {string|null} existingToken optional
 * @param {string} apiHash base64 encoding of client id and secret
 * @returns {Promise}
 */


var refreshToken = function refreshToken(existingToken, apiHash) {
  logger.info("".concat(MODULE_NAME, " - refreshToken called"), existingToken);

  if (!_config.default.hasValidConfig()) {
    console.error('nsSDK not configured');
    return Promise.reject(false);
  }

  var _config$getConfigurat4 = _config.default.getConfiguration(),
      apiURL = _config$getConfigurat4.apiURL;

  var token = existingToken || tokenUtil.get();
  return (0, _axios.default)({
    method: 'post',
    url: "".concat(apiURL, "oauth2/netsapiensJs/"),
    data: {
      grant_type: 'refresh_token',
      refresh_token: token
    },
    withCredentials: true,
    headers: {
      Authorization: "Basic ".concat(apiHash)
    }
  }).then(function (res) {
    tokenUtil.set(res.data.token);
    return res.data.token;
  });
};

var _default = {
  get: get,
  getLogo: getLogo,
  post: post,
  refreshToken: refreshToken
};
exports.default = _default;
module.exports = exports.default;